import React from 'react';
import styles from './NotificationModal.module.scss';
import Placeholder from 'assets/img/notifications-placeholder.png';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';

export const NotificationsPlaceholder = () => {
  const i18n = useScopedTranslation('Page.NotificationModal');
  return (
    <div className={styles.placeholderContainer}>
      <img src={Placeholder} />
      <div className={styles.placeholderTitle}>
        {i18n.t('no_notifications_title')}
      </div>
      <div className={styles.placeholderText}>
        {i18n.t('no_notifications_text')}
      </div>
    </div>
  );
};
